import { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';
import { buildQrStylingOptions } from '../../utils/qrDesign';

export default function QrStyledRenderer({ value, style, renderSize, instanceRef }) {
  const containerRef = useRef(null);
  const localInstanceRef = useRef(null);

  useEffect(() => {
    if (!value || !containerRef.current) {
      return undefined;
    }

    const options = buildQrStylingOptions(value, style, renderSize);

    if (!localInstanceRef.current) {
      localInstanceRef.current = new QRCodeStyling(options);
      containerRef.current.innerHTML = '';
      localInstanceRef.current.append(containerRef.current);
    } else {
      localInstanceRef.current.update(options);
    }

    if (instanceRef) {
      instanceRef.current = localInstanceRef.current;
    }

    return undefined;
  }, [value, style, renderSize, instanceRef]);

  useEffect(() => {
    if (!value && containerRef.current) {
      containerRef.current.innerHTML = '';
      localInstanceRef.current = null;
      if (instanceRef) instanceRef.current = null;
    }
  }, [value, instanceRef]);

  return <div ref={containerRef} className="[&_canvas]:max-w-full" />;
}
